import ResumeBuilderList from "./candidateList";

export default ResumeBuilderList;